// extracted by mini-css-extract-plugin
export var errorTextAbove = "progressBar-module--errorTextAbove--17ecb";
export var errorTextBelow = "progressBar-module--errorTextBelow--d3c25";
export var textAbove = "progressBar-module--textAbove--26f98";
export var textBelow = "progressBar-module--textBelow--5bf9c";